import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
  } from 'chart.js';
import PropTypes from "prop-types";


  
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip
  );



export default function BarChart(props){
    return <div>
        <h2>{props.title}</h2>
        <Bar data={props.data} options={{
            
    responsive:true,
    indexAxis: 'y',
    animation: {
        animateScale:true
    },
    scales:{
        x:{ticks:{precision: 0}},
        y:{ticks:{
            align:'start'
        }}
    },
    


  }}></Bar>
    </div>
}

BarChart.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired
}